import React from "react"
import PropTypes from "prop-types"
import Dropzone from "react-dropzone"

const DropezoneInput = ({input}) => {
  const file = input.value
  return (
    <Dropzone accept="image/jpeg, image/png" style={{}} onDrop={files => input.onChange(files[0])} >
      {!file && <span className="product-image-button">Choose file</span>}
      {file && <img className="product-image-preview" src={file.preview} />}
    </Dropzone>
  )
}

DropezoneInput.propTypes = {
  input: PropTypes.object.isRequired
}

export default DropezoneInput
